import { Injectable } from '@angular/core';

// Hands the MasterRow that HospitalOnboardComponent.startUpload() opened this
// popup for across to FacilityUserOnboardingComponent - the two aren't
// directly nested (HospitalOnboardComponent opens a ResourcePopupComponent
// whose embedded <app-ui-engine> mounts FacilityUserOnboardingComponent
// dynamically via a tab-layout JSON), so an @Input() can't reach it. Set
// right before opening the popup, read once in ngOnInit().
@Injectable({ providedIn: 'root' })
export class FacilityUserOnboardingContextService {
  private row: any;

  setRow(row: any): void {
    this.row = row;
  }

  getRow(): any {
    return this.row;
  }
}
